/**
 * `@eis/partnerservice-sdk` — the generated client for the Partner service's REST API.
 *
 * `./generated` comes from api/openapi/vendor/partnerservice_openapi_spec.json — the document the
 * Partner domain PUBLISHED, vendored verbatim (SDD-014 PS-11) — via `pnpm gen:sdk`; never hand-edited,
 * diffed by `make gen-check` (rule 26). The types are re-exported wholesale under one namespace, so
 * a call site says `PartnerApi.PartnerClass` and never re-declares a shape another team owns.
 *
 * Built with `createForeignClient`, deliberately NOT `createEisClient`: the latter turns the
 * platform's ETag/If-Match concurrency middleware on, and the Partner service is not party to that
 * contract — it emits no ETag, ignores If-Match, and answers a duplicate partner number with a bare
 * 409 the middleware would misreport as "the data changed, reload" (README, PROBE.md §6). Bearer
 * auth, traceparent (T-13) and the session refresh (SDD-019) come from the shared runtime, so a
 * token refresh or a trace propagates here exactly as it does everywhere else.
 */
import type { Client } from 'openapi-fetch';
import { createForeignClient, type ForeignClientOptions } from '@eis/sdk-runtime';
import type { paths } from './generated/partnerservice.v1';

export type * as PartnerApi from './generated/partnerservice.v1';
export type { TokenProvider, TraceparentProvider } from '@eis/sdk-runtime';
export {
  createSessionRefreshMiddleware,
  isSafeToReplay,
  type SessionRefreshOptions,
} from '@eis/sdk-runtime';

/**
 * `baseUrl` is the ORIGIN the service's paths are mounted under — `/api` behind the console's
 * reverse proxy, never `/api/<service>`: the generated paths already carry the service's own
 * prefix, and Caddy strips only `/api`.
 */
export type PartnerServiceClientOptions = ForeignClientOptions;

export type PartnerServiceClient = Client<paths>;

export function createPartnerServiceClient(
  options: PartnerServiceClientOptions,
): PartnerServiceClient {
  return createForeignClient<paths>(options);
}
